const loadedScripts = new Map();

export function importExternalScript(scriptSrc) {
    if (loadedScripts.has(scriptSrc)) {
        return loadedScripts.get(scriptSrc);
    }
    const scriptPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.onload = resolve;
        script.src = scriptSrc;
        script.async = true;
        script.onerror = reject;

        document.body.appendChild(script);
    });
    loadedScripts.set(scriptSrc, scriptPromise);
    return scriptPromise;
}
